import React from 'react'

import config from '../../config.js'

import 'Skelet/src/start.css'; // importing this seems to make it get stuck, so even on other routes and containers the css is still there.

import StartFooter from 'Skelet/src/components/Start_Footer.js'


export default class StartRoute extends React.Component {

  render() {
    return (
      <div>
        <div className="start">
          <main>
            {React.createElement(this.props.component, {
              config,
              location:this.props.location
            })}
          </main>
          <StartFooter />
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/route-containers/StartRoute.js